// extracted by mini-css-extract-plugin
export default {"AnimalCard":"AnimalCard_AnimalCard__oHSA4","isSelected":"AnimalCard_isSelected__vGf82"};